//action types
export const SET_SELECTED_SCHOOL_INDEX = "SET_SELECTED_SCHOOL_INDEX";

//action creators
export function setSelectedSchool(schoolIndex) {
    return {
        type: SET_SELECTED_SCHOOL_INDEX,
        schoolIndex,
    }
}